import { render, staticRenderFns } from "./pigeon.vue?vue&type=template&id=c050fa80&scoped=true&"
import script from "./pigeon.vue?vue&type=script&lang=js&"
export * from "./pigeon.vue?vue&type=script&lang=js&"
import style0 from "./pigeon.vue?vue&type=style&index=0&id=c050fa80&scoped=true&lang=scss&"
import style1 from "./pigeon.vue?vue&type=style&index=1&id=c050fa80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c050fa80",
  null
  
)

export default component.exports